<template>
  <div class="MyOrder">
    <ul class="tagList">
      <li
        :class="{ selected: form_head_uuid === item.form_head_uuid }"
        v-for="(item, index) in tagList"
        :key="'tag' + index"
        @click="changeIndex(item.form_head_uuid)"
      >
        {{ item.name }}
      </li>
    </ul>
    <template v-if="show">
      <ApprovalList
        v-if="
          [
            '403e15205bc248f48d8a3626571c4e56',
            '91e9bb4eac0a48b38e8327cc9c6c23de',
            '33d336e546644de7afb25e1989757d93'
          ].includes(form_head_uuid)
        "
        form_id="436ae44d1c60475a9b4009ca40edc11e"
        :form_head_uuid="form_head_uuid"
      />
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Popup from "../../components/Popup";
import ApprovalList from '@/components/ApprovalList.vue';
export default {
  name: "MyOrder",
  components: {
    Popup,
    ApprovalList,
  },
  computed: {
    ...mapState(["clientToken"]),
  },
  data () {
    return {
      tagList: [
        { name: "审核中", form_head_uuid: "403e15205bc248f48d8a3626571c4e56" },
        { name: "审核成功", form_head_uuid: "91e9bb4eac0a48b38e8327cc9c6c23de", },
        { name: "审核失败", form_head_uuid: "33d336e546644de7afb25e1989757d93", },
      ],
      form_head_uuid: "403e15205bc248f48d8a3626571c4e56",
      orderList: [],
      popupShow: false,
      curOrderId: "",
      curCommentGoodsId: "",
      curCommentGoodsDetailId: "",
      curStar: 0,
      hasClickStar: false,
      comment: "",
      //分页
      page: 1,
      total: 0,
      limit: 20,
      show: true,
    };
  },
  created () {
  },
  mounted () {
  },
  methods: {
    changeIndex (form_head_uuid) {
      this.page = 1;
      this.form_head_uuid = form_head_uuid;
      if (['403e15205bc248f48d8a3626571c4e56', '91e9bb4eac0a48b38e8327cc9c6c23de', '33d336e546644de7afb25e1989757d93'].includes(form_head_uuid)) {
        this.show = false;
        setTimeout(() => {
          this.show = true;
        }, 300)
      }
    },
    navTo (route) {
      this.$router.push(route);
      this.$store.commit('setData', {
        form_head_uuid: this.form_head_uuid
      })
    },
  },
};
</script>

<style scoped lang="less">
@import '../../assets/css/var.less';
@import '../../css/order.less';
.MyOrder {
  .tagList {
    li {
      text-align: center;
      display: inline-block;
      font-weight: 550;
      font-size: 18px;
      border-bottom: 2px solid @borderColor;
      cursor: pointer;
      padding: 10px 20px;
      position: relative;
      &:after {
        top: 12px;
        right: 0;
        position: absolute;
        content: '';
        width: 1px;
        height: 15px;
        background-color: @borderColor;
      }
      &:last-child {
        &:after {
          display: none;
        }
      }
    }
    .selected {
      color: @thirdColor;
      border-bottom: 2px solid @thirdColor;
    }
  }
  .popupContent {
    padding: 10px;
    .scoreBox {
      width: 100%;
      height: 50px;
      position: relative;
      line-height: 50px;
      text-align: left;
      .tips {
        font-size: 15px;
        vertical-align: middle;
        display: inline-block;
      }
      i {
        cursor: pointer;
        vertical-align: middle;
        display: inline-block;
        font-size: 25px;
        margin-right: 5px;
        -webkit-text-stroke: 1px #f9bd4f;
      }
    }
    textarea {
      width: 400px;
      height: 80px;
      padding: 5px;
      border: 1px solid @borderColor;
      display: block;
      margin-top: 10px;
    }
    button {
      display: block;
      margin: 10px auto;
      width: 70px;
      height: 30px;
      border-radius: 3px;
      background-color: #313541;
      color: white;
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/client/Purchase.vue